@if (inlineActions?.length) {
    @for (action of inlineActions; track action.name; let last = $last) {
        <pf-button
            class="table-action"
            buttonType="action"
            centered
            [title]="action.tooltip || ''"
            (click)="actionClicked(action)"
            [disabled]="!!action.disable">
            <pf-text [type]="action.textType" class="wrap-text" small
                >{{ action.name }}
            </pf-text>
        </pf-button>
        @if (!last) {
            <nz-divider nzType="vertical"></nz-divider>
        }
    }
}
@if (moreActions?.length) {
    <nz-divider nzType="vertical"></nz-divider>
    <pf-icon
        class="table-action-menu-trigger"
        iconType="inlineMenu"
        nz-dropdown
        nzTrigger="click"
        [nzDropdownMenu]="menu"
        nzOverlayClassName="table-actions-menu"></pf-icon>
    <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
            @for (action of moreActions; track action) {
                <li
                    nz-menu-item
                    [title]="action.tooltip || ''"
                    (click)="actionClicked(action)"
                    [nzDisabled]="!!action.disable">
                    <pf-text [type]="action.textType"
                        >{{ action.name }}
                    </pf-text>
                </li>
            }
        </ul>
    </nz-dropdown-menu>
}
